import React, { useEffect, useRef } from 'react'; // ✅ thêm useRef, useEffect
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import {is_pick_ranking} from '../../util';
import {Url} from "../../../../common/constants/environment";

const NavMenu = ({}) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const isHoldem = location.pathname.includes('holdem');
  //const isNotLadder = location.pathname.includes('minigame/ladder') === false;
  const isRanking = is_pick_ranking();
  const tab = query.get('tab') || (isRanking? 'pick_rank': 'result');
//  const isRanking = path[2] === 'rball';

  const scrollRef = useRef(null);

// Auto scroll to right when mounted
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        left: scrollRef.current.scrollWidth,
        behavior: 'smooth'
      });
    }
  }, []);


  return (
    <div className="snb_wrap" ref={scrollRef} >
      <ul>
        {isRanking &&
            <li>
              <Link
                  to={`${location.pathname}?tab=pick_rank`}
                  className={clsx('item', tab === 'pick_rank' && 'selected')}
              >
                랭킹
              </Link>
            </li>
        }
        <li>
          <Link
              to={`${location.pathname}?tab=result`}
              className={clsx('item', tab === 'result' && 'selected')}
          >
            결과
          </Link>
        </li>
        <li>
          <Link
              to={`${location.pathname}?tab=room_chat`}
              className={clsx('item', tab === 'room_chat' && 'selected')}
          >
            테마채팅
          </Link>
        </li>
        {isHoldem ? (
            <li>
              <Link
                  to={`${location.pathname}?tab=guide`}
                  className={clsx('item', tab === 'guide' && 'selected')}
              >
                설명
              </Link>
            </li>
        ) : (
            <>
              <li>
                <Link
                    to={`${location.pathname}?tab=analysis`}
                    className={clsx('item', tab === 'analysis' && 'selected')}
                >
                  분석
                </Link>
              </li>
              <li>
                <Link
                    to={`${location.pathname}?tab=pick`}
                    className={clsx('item', tab === 'pick' && 'selected')}
                >
                  게임픽
                </Link>
              </li>
            </>
        )}
          <li>
          <Link 
            to={`${location.pathname}?tab=banner`}
            className={clsx('item', tab === 'banner' && 'selected')}
          >
            <div style={{justifyContent: "center", alignItems: "center"}}>
              <img src={Url.imageNamed + "portal/ic_new.png"} style={{marginRight: "2px",width:"16px"}}/>
              이용가능 사이트
            </div>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export {NavMenu};
